import { cn } from '@/shared/lib'

interface PillTabOption<V extends string> {
  value: V
  label: string
  count?: number
}

interface PillTabsProps<V extends string> {
  options: ReadonlyArray<PillTabOption<V>>
  value: V
  onChange: (value: V) => void
  'aria-label': string
  className?: string
}

export function PillTabs<V extends string>({
  options,
  value,
  onChange,
  className,
  ...rest
}: PillTabsProps<V>) {
  return (
    <div
      role="tablist"
      aria-label={rest['aria-label']}
      className={cn('flex flex-wrap gap-2', className)}
    >
      {options.map((option) => {
        const active = option.value === value
        return (
          <button
            key={option.value}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(option.value)}
            className={cn(
              'inline-flex h-9 items-center gap-1.5 rounded-full px-4 text-body-sm font-medium transition-colors',
              active
                ? 'bg-pill-active-bg text-pill-active-fg'
                : 'bg-raise text-muted hover:bg-hover hover:text-app-fg',
            )}
          >
            {option.label}
            {option.count !== undefined && (
              <span className={cn('text-caption', active ? 'opacity-60' : 'text-faint')}>
                {option.count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
